(function () {
    'use strict';

    function linkResourcesGroupConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/linkResourcesGroupConfiguration.html',
            link: function (scope) {
            }
        };
    }

    linkResourcesGroupConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('linkResourcesGroupConfiguration', linkResourcesGroupConfiguration);
})();

